import { makeActionCreator } from '../../../../utilities'
import { RespiratoryConstant } from './respiratory.constant'

export const setBreathSoundsLeft = makeActionCreator(RespiratoryConstant.SET_BREATHSOUNDS_LEFT, 'cvBreathSoundsL')
export const setBreathSoundsRight = makeActionCreator(RespiratoryConstant.SET_BREATHSOUNDS_RIGHT, 'cvBreathSoundsR')
export const setBreathSoundsComments = makeActionCreator(
  RespiratoryConstant.SET_BREATHSOUNDS_COMMENT,
  'cvBreathComments'
)
export const setRespiratoryEffort = makeActionCreator(RespiratoryConstant.SET_RESPIRATORY_EFFORT, 'cvRespEffort')
export const setO2 = makeActionCreator(RespiratoryConstant.SET_O2, 'cvO2')
export const setRFIO2 = makeActionCreator(RespiratoryConstant.SET_RFIO2, 'rfio2')
export const setFIO2AirTemp = makeActionCreator(RespiratoryConstant.SET_FIO2AirTemp, 'fio2AirTemp')
export const setFIO2AirTempUnit = makeActionCreator(RespiratoryConstant.SET_FIO2AirTemp_UNIT, 'fio2AirTempUnit')
export const setFIO2Humidity = makeActionCreator(RespiratoryConstant.SET_FIO2Humidity, 'fio2Humidity')
export const setVia = makeActionCreator(RespiratoryConstant.SET_VIA, 'cvVia')
export const setPerformedBy = makeActionCreator(RespiratoryConstant.SET_PERFORMEDBY, 'respBy')
export const setOutcome = makeActionCreator(RespiratoryConstant.SET_OUTCOME, 'respOutcome')
export const setRespComments = makeActionCreator(RespiratoryConstant.SET_RESP_COMMENT, 'respComments')
export const setRespExam = makeActionCreator(RespiratoryConstant.SET_RESP_EXAM, 'respExam')
export const setRespiratory = makeActionCreator(RespiratoryConstant.SET_RESPIRATORY, 'respiratory')
export const saveRespiratory = makeActionCreator(RespiratoryConstant.SAVE_RESPIRATORY)
export const resetRespiratoryState = makeActionCreator(RespiratoryConstant.RESET_STATE)
